module.exports = __webpack_public_path__ + "static/reason-2-d8abe1a4d5db958b637fcae1bbbb83c6.svg";